var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDiscover = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 68,
    viewBox: "0 0 105 68",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M77.344 28.333L77.344 0 0 0 0 28.333z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__c",
    d: "M46.004.253C41.94.253 38.64 3.64 38.64 7.81c0 4.441 3.157 7.756 7.364 7.756 4.103 0 7.346-3.36 7.346-7.668 0-4.278-3.22-7.644-7.346-7.644"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 68,
    fill: "#FFF",
    rx: 11.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.011 36.833)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4811F",
    d: "M77.344 0S50.028 19.573 0 28.333h77.344V0z",
    mask: "url(#prefix__b)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 102.188,
    height: 65.188,
    x: 1.406,
    y: 1.406,
    stroke: "#979797",
    strokeWidth: 2.813,
    rx: 5.625
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.5 20.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001722",
    d: "M4.203.535H.246v14.698H4.18c2.095 0 3.602-.525 4.928-1.695 1.574-1.386 2.507-3.485 2.507-5.647 0-4.34-3.046-7.356-7.412-7.356zm3.15 11.04c-.853.817-1.948 1.17-3.69 1.17H2.94V3.019h.723c1.742 0 2.796.333 3.69 1.19.93.885 1.485 2.251 1.485 3.661 0 1.414-.555 2.827-1.484 3.705zM12.856.535L15.546.535 15.546 15.233 12.856 15.233zM22.133 6.172c-1.618-.637-2.094-1.058-2.094-1.847 0-.93.847-1.634 2.012-1.634.806 0 1.47.352 2.173 1.186l1.406-1.956C24.475.836 23.085.287 21.572.287c-2.44 0-4.306 1.807-4.306 4.207 0 2.03.87 3.068 3.395 4.04 1.057.394 1.596.658 1.866.838.536.376.809.902.809 1.519 0 1.193-.895 2.074-2.097 2.074-1.282 0-2.317-.684-2.939-1.962l-1.735 1.786c1.237 1.939 2.729 2.8 4.782 2.8 2.795 0 4.76-1.986 4.76-4.827 0-2.34-.908-3.397-3.974-4.59M26.956 7.89c0 4.326 3.186 7.675 7.289 7.675 1.158 0 2.151-.244 3.373-.857v-3.373c-1.076 1.146-2.03 1.607-3.253 1.607-2.71 0-4.635-2.095-4.635-5.072 0-2.82 1.986-5.047 4.515-5.047 1.282 0 2.256.485 3.373 1.654V1.101C36.44.464 35.467.203 34.308.203c-4.08 0-7.352 3.416-7.352 7.688M59.442 10.409L55.755.535 52.817.535 58.677 15.609 60.124 15.609 66.086.535 63.17.535 59.442 10.409M67.311 15.233L74.952 15.233 74.952 12.745 70.002 12.745 70.002 8.775 74.761 8.775 74.761 6.284 70.002 6.284 70.002 3.019 74.952 3.019 74.952.535 67.311.535 67.311 15.233M85.61 4.87c0-2.752-1.777-4.335-4.883-4.335h-3.998v14.698h2.693V9.325h.353l3.725 5.908h3.312l-4.35-6.193c2.034-.44 3.148-1.919 3.148-4.17zM80.206 7.3h-.784V2.844h.829c1.678 0 2.592.753 2.592 2.183 0 1.475-.914 2.275-2.637 2.275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M87.562 1.654c0-.277-.172-.424-.485-.424h-.417v1.373h.306V2.07l.36.532h.384l-.43-.568c.181-.05.282-.194.282-.381zm-.542.183h-.054v-.36h.06c.152 0 .226.065.226.18 0 .12-.077.18-.232.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M87.11.741c-.586 0-1.062.506-1.062 1.133 0 .63.479 1.132 1.063 1.132.577 0 1.047-.509 1.047-1.132 0-.62-.47-1.133-1.047-1.133zm0 2.062c-.475 0-.853-.414-.853-.926 0-.519.378-.929.854-.929.457 0 .834.42.834.93 0 .508-.377.925-.834.925z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F58220",
    xlinkHref: "#prefix__c"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiscover, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/discover.361ce134.svg";
export { ForwardRef as ReactComponent };